import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Keeps <html lang="..."> in sync with the current i18n language.
 */
export function LangAttributeSync() {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.lang = i18n.language?.startsWith('en') ? 'en' : 'it';
  }, [i18n.language]);

  return null;
}
